/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { ICON_DEFAULT_STYLE } from "@/shared";

import { Colors, PublicIcon } from "@dotnet/telematics-design-system";

import Tooltip from "../../../Tooltip/Tooltip";

interface GlobalScheduleIconProps {
  specificGlobalSchedule: string | null;
  colors: Colors;
}

const GlobalScheduleIcon = ({
  specificGlobalSchedule,
  colors
}: GlobalScheduleIconProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t(`Schedules##global schedule##global icon info`, {
        specificGlobalSchedule: specificGlobalSchedule
      })}
      size="medium"
      placement="top"
      hasArrow
    >
      <PublicIcon
        css={css({
          ...ICON_DEFAULT_STYLE,
          color: colors.textDark,
          display: "flex",
          marginRight: "4px"
        })}
        data-testid="schedules-info-icon"
      />
    </Tooltip>
  );
};

export default GlobalScheduleIcon;
